import { createClient } from "@supabase/supabase-js"

const supabaseUrl = process.env.VUE_APP_SUPABASE_URL
const supabaseAnonKey = process.env.VUE_APP_SUPABASE_ANON_KEY

let supabaseInstace = null;
if (supabaseUrl && supabaseAnonKey) {
  supabaseInstace = createClient(supabaseUrl, supabaseAnonKey);
}
export const supabase = supabaseInstace;